import React from 'react';
import { Box, styled } from '@mui/material';

const FormLabel = styled(Box)(({ theme }) => ({
  //backgroundColor:'#ddd',
  ...theme.typography.subtitle2,
  borderRight: (theme) => `1px solid ${theme.palette.divider}`,
  // textAlign: 'left',
  px: 1,
}));

export default FormLabel;
